module.exports = __webpack_public_path__ + "static/img/hold.d740db6a.png";